'use strict';

module.exports = {
  hideYearsOnSelect: true,
  layout: 'portrait',
  overscanMonthCount: 2,
  shouldHeaderAnimate: true,
  showHeader: true,
  showMonthsForYears: true,
  showOverlay: true,
  showTodayHelper: true,
  showWeekdays: true,
  todayHelperRowOffset: 4
};


//////////////////
// WEBPACK FOOTER
// ./~/react-infinite-calendar/lib/utils/defaultDisplayOptions.js
// module id = 850
// module chunks = 0